export const hide = (...elems: HTMLElement[]): void =>
  elems.forEach(e => e.classList.add('wz-hidden'))

export const show = (...elems: HTMLElement[]): void =>
  elems.forEach(e => e.classList.remove('wz-hidden'))

/* IE is not implementing element.classList.toggle second argument, so we need this. */
export const toggleClass = (elem: HTMLElement, className: string, force?: boolean): void => {
  if (force !== undefined) {
    if (force) {
      elem.classList.add(className)
    } else {
      elem.classList.remove(className)
    }

    return
  }

  elem.classList.toggle(className)
}

export const setTextWithNewlines = (el: HTMLElement, text: string): void => {
  el.innerHTML = ''
  text.split('[br]').forEach((s, i) => {
    if (i !== 0) {
      el.appendChild(document.createElement('br'))
    }
    el.appendChild(document.createTextNode(s))
  })
}
